import { useCallback } from "react"
import { IconCreditCardOutline18 as CreditCard } from "nucleo-ui-outline-18"

import { Alert, Button } from "@productlane/ui"

import type { PaymentIssue } from "@/lib/useTrial"
import { paymentIssueCopy } from "@/lib/payment-issue"
import { SETTINGS_INSET_CLASS } from "../settings-switches/settings-container"
import { useStripePortal } from "./billing-details"

interface PaymentIssueAlertProps {
	issue: PaymentIssue
}

export function PaymentIssueAlert({ issue }: PaymentIssueAlertProps) {
	const portal = useStripePortal()
	const { header, body } = paymentIssueCopy(issue)

	const onClick = useCallback(() => {
		// The hosted invoice page settles the open invoice in one step; the portal
		// is the fallback when Stripe gave us no link.
		if (issue.invoiceUrl) {
			window.open(issue.invoiceUrl, "_blank", "noopener,noreferrer")
			return
		}
		void portal.open()
	}, [issue.invoiceUrl, portal])

	return (
		<Alert
			variant={issue.status === "unpaid" ? "error" : "warning"}
			header={header}
			className={SETTINGS_INSET_CLASS}
		>
			<div className="flex flex-col items-start gap-3">
				<span>{body}</span>
				<Button
					variant="outline"
					Icon={CreditCard}
					isLoading={portal.isLoading}
					disabled={portal.isLoading}
					onClick={onClick}
				>
					{issue.invoiceUrl ? "Pay invoice" : "Update payment method"}
				</Button>
			</div>
		</Alert>
	)
}
